/* 
iconMap is a map of icon names to icon components
The key is the MUI icon and the value is the Lucide icon name 
*/
export const iconMap = {
  Abc: 'CaseSensitive',
  AbcOutlined: 'CaseSensitive',
  AbcRounded: 'CaseSensitive',
  AbcTwoTone: 'CaseSensitive',
  AccessAlarm: 'AlarmClock',
  AccessAlarmOutlined: 'AlarmClock',
  AccessAlarms: 'AlarmClock',
  AccessAlarmSharp: 'AlarmClock',
  AccessAlarmsOutlined: 'AlarmClock',
  AccessAlarmsSharp: 'AlarmClock',
  AccessAlarmsTwoTone: 'AlarmClock',
  AccessAlarmTwoTone: 'AlarmClock',
  Accessibility: 'Accessibility',
  AccessibilityNew: 'Accessibility',
  AccessibilityNewOutlined: 'Accessibility',
  AccessibilityNewRounded: 'Accessibility',
  AccessibilityNewSharp: 'Accessibility',
  AccessibilityNewTwoTone: 'Accessibility',
  AccessibilityOutlined: 'Accessibility',
  AccessibilitySharp: 'Accessibility',
  AccessibilityTwoTone: 'Accessibility',
  Accessible: 'Accessibility',
  AccessibleForward: 'Accessibility',
  AccessibleForwardOutlined: 'Accessibility',
  AccessibleForwardRounded: 'Accessibility',
  AccessibleForwardSharp: 'Accessibility',
  AccessibleForwardTwoTone: 'Accessibility',
  AccessibleOutlined: 'Accessibility',
  AccessibleSharp: 'Accessibility',
  AccessibleTwoTone: 'Accessibility',
  AccessTime: 'Clock',
  AccessTimeFilled: 'Clock',
  AccessTimeFilledOutlined: 'Clock',
  AccessTimeFilledTwoTone: 'Clock',
  AccessTimeOutlined: 'Clock',
  AccessTimeRounded: 'Clock',
  AccessTimeSharp: 'Clock',
  AccessTimeTwoTone: 'Clock',
  AccountBalance: 'Landmark',
  AccountBalanceOutlined: 'Landmark',
  AccountBalanceRounded: 'Landmark',
  AccountBalanceSharp: 'Landmark',
  AccountBalanceTwoTone: 'Landmark',
  AccountBalanceWallet: 'Wallet',
  AccountBalanceWalletOutlined: 'Wallet',
  AccountBalanceWalletRounded: 'Wallet',
  AccountBalanceWalletSharp: 'Wallet',
  AccountBalanceWalletTwoTone: 'Wallet',
  AccountBox: 'SquareUser',
  AccountBoxOutlined: 'SquareUser',
  AccountBoxRounded: 'SquareUser',
  AccountBoxTwoTone: 'SquareUser',
  AccountCircle: 'CircleUser',
  AccountCircleOutlined: 'CircleUser',
  AccountCircleRounded: 'CircleUser',
  AccountCircleSharp: 'CircleUser',
  AccountCircleTwoTone: 'CircleUser',
  AccountTree: 'GitBranch',
  AccountTreeOutlined: 'GitBranch',
  AccountTreeRounded: 'GitBranch',
  AccountTreeSharp: 'GitBranch',
  AccountTreeTwoTone: 'GitBranch',
  AcUnit: 'Snowflake',
  AcUnitOutlined: 'Snowflake',
  AcUnitSharp: 'Snowflake',
  AcUnitTwoTone: 'Snowflake',
  Adb: 'Smartphone',
  AdbOutlined: 'Smartphone',
  AdbRounded: 'Smartphone',
  AdbSharp: 'Smartphone',
  AdbTwoTone: 'Smartphone',
  Add: 'Plus',
  AddAlarm: 'AlarmClockPlus',
  AddAlarmOutlined: 'AlarmClockPlus',
  AddAlarmRounded: 'AlarmClockPlus',
  AddAlarmSharp: 'AlarmClockPlus',
  AddAlarmTwoTone: 'AlarmClockPlus',
  AddAlert: 'BellPlus',
  AddAlertOutlined: 'BellPlus',
  AddAlertRounded: 'BellPlus',
  AddAlertSharp: 'BellPlus',
  AddAPhoto: 'ImagePlus',
  AddAPhotoOutlined: 'ImagePlus',
  AddAPhotoRounded: 'ImagePlus',
  AddAPhotoSharp: 'ImagePlus',
  AddAPhotoTwoTone: 'ImagePlus',
  AddBusiness: 'Building2',
  AddBusinessTwoTone: 'Building2',
  AddCard: 'CreditCard',
  AddCardSharp: 'CreditCard',
  AddHomeWorkOutlined: 'HousePlus',
  AddIcCallTwoTone: 'Phone',
  AddPhotoAlternate: 'ImagePlus',
  AddPhotoAlternateOutlined: 'ImagePlus',
  AddPhotoAlternateRounded: 'ImagePlus',
  AddPhotoAlternateTwoTone: 'ImagePlus',
  AddRoad: 'Route',
  AddRoadTwoTone: 'Route',
  AddShoppingCart: 'ShoppingCart',
  AddShoppingCartOutlined: 'ShoppingCart',
  AddShoppingCartRounded: 'ShoppingCart',
  AddToDrive: 'HardDriveUpload',
  AddToDriveOutlined: 'HardDriveUpload',
  AdjustSharp: 'Contrast',
  AdUnits: 'Smartphone',
  AdUnitsOutlined: 'Smartphone',
  AdUnitsRounded: 'Smartphone',
  AdUnitsSharp: 'Smartphone',
  AdUnitsTwoTone: 'Smartphone',
  AgricultureRounded: 'Tractor',
  Air: 'Wind',
  AirlineSeatLegroomExtraTwoTone: 'Armchair',
  AirlineSeatReclineExtra: 'Armchair',
  AirlineSeatReclineExtraOutlined: 'Armchair',
  AirlineSeatReclineExtraSharp: 'Armchair',
  AirlineSeatReclineNormalSharp: 'Armchair',
  AirplanemodeActive: 'Plane',
  AirplanemodeActiveSharp: 'Plane',
  AirportShuttleTwoTone: 'Bus',
  AlbumSharp: 'DiscAlbum',
  AlignHorizontalCenter: 'AlignCenterHorizontal',
  AlignHorizontalCenterOutlined: 'AlignCenterHorizontal',
  AnnouncementTwoTone: 'Megaphone',
  ApartmentOutlined: 'Building',
  Approval: 'BadgeCheck',
  ApprovalOutlined: 'BadgeCheck',
  ApprovalSharp: 'BadgeCheck',
  AppSettingsAlt: 'Settings',
  ArrowCircleLeftOutlined: 'CircleArrowLeft',
  ArrowCircleRight: 'CircleArrowRight',
  ArrowCircleRightOutlined: 'CircleArrowRight',
  ArrowCircleRightRounded: 'CircleArrowRight',
  ArrowCircleRightSharp: 'CircleArrowRight',
  ArrowUpward: 'ArrowUp',
  AssignmentLateOutlined: 'ClipboardList',
  AssignmentReturn: 'Undo2',
  AssignmentReturnOutlined: 'Undo2',
  AssignmentTurnedInSharp: 'ClipboardCheck',
  AssistantDirectionOutlined: 'Navigation',
  AssistantPhotoRounded: 'Image',
  AttachMoney: 'DollarSign',
  AttachMoneyOutlined: 'DollarSign',
  AttachMoneyRounded: 'DollarSign',
  AutoFixHigh: 'WandSparkles',
  AutoFixOffRounded: 'Wand',
  AutorenewRounded: 'RefreshCw',
  BabyChangingStation: 'Baby',
  Battery0BarRounded: 'Battery',
  Battery3BarOutlined: 'BatteryLow',
  Battery6BarSharp: 'BatteryMedium',
  BatteryAlert: 'BatteryWarning',
  BatteryCharging90TwoTone: 'BatteryCharging',
  Bed: 'Bed',
  BedroomChildOutlined: 'Baby',
  Beenhere: 'MapPinCheck',
  BeenhereOutlined: 'MapPinCheck',
  BeenhereTwoTone: 'MapPinCheck',
  BiotechOutlined: 'FlaskConical',
  BlindsClosedTwoTone: 'Blinds',
  BluetoothDrive: 'Bluetooth',
  Bolt: 'Zap',
  BoltOutlined: 'Zap',
  BookmarkAdded: 'BookmarkCheck',
  BookmarkAddedTwoTone: 'BookmarkCheck',
  BookmarkAddRounded: 'BookmarkPlus',
  BookOnlineOutlined: 'BookOpen',
  BorderColorOutlined: 'SquarePen',
  BrightnessHighSharp: 'Sun',
  BrightnessHighTwoTone: 'Sun',
  BrightnessLowRounded: 'SunDim',
  BrokenImageOutlined: 'ImageOff',
  BrowserUpdated: 'RefreshCw',
  Brush: 'Brush',
  BrushOutlined: 'Brush',
  BrushRounded: 'Brush',
  BrushSharp: 'Brush',
  BugReport: 'Bug',
  BugReportOutlined: 'Bug',
  Build: 'Wrench',
  BuildCircleOutlined: 'Wrench',
  BuildCircleSharp: 'Wrench',
  BuildCircleTwoTone: 'Wrench',
  BuildOutlined: 'Wrench',
  BusAlert: 'Bus',
  BusAlertRounded: 'Bus',
  CalculateOutlined: 'Calculator',
  CalendarMonth: 'Calendar',
  CalendarMonthOutlined: 'Calendar',
  CameraAlt: 'Camera',
  CameraAltOutlined: 'Camera',
  CameraAltRounded: 'Camera',
  CameraAltTwoTone: 'Camera',
  CameraEnhanceOutlined: 'Camera',
  CameraEnhanceSharp: 'Camera',
  CameraIndoorRounded: 'Cctv',
  CancelScheduleSendSharp: 'CalendarX',
  CarCrash: 'Car',
  CarCrashOutlined: 'Car',
  CarCrashRounded: 'Car',
  CarCrashSharp: 'Car',
  CarCrashTwoTone: 'Car',
  CardGiftcard: 'Gift',
  CardMembership: 'CreditCard',
  CardTravelTwoTone: 'Briefcase',
  CarRental: 'Car',
  CarRentalOutlined: 'Car',
  CarRentalRounded: 'Car',
  CarRentalSharp: 'Car',
  CarRentalTwoTone: 'Car',
  CarRepair: 'Car',
  CarRepairOutlined: 'Car',
  CarRepairRounded: 'Car',
  CarRepairSharp: 'Car',
  CarRepairTwoTone: 'Car',
  Chair: 'Armchair',
  ChairAltTwoTone: 'Armchair',
  ChairOutlined: 'Armchair',
  ChairRounded: 'Armchair',
  ChangeCircleOutlined: 'RefreshCw',
  Check: 'Check',
  CheckBox: 'SquareCheck',
  CheckBoxOutlined: 'SquareCheck',
  CheckBoxRounded: 'SquareCheck',
  CheckBoxTwoTone: 'SquareCheck',
  CheckCircle: 'CheckCircle2',
  CheckCircleOutline: 'Circle',
  CheckCircleOutlined: 'CheckCircle2',
  CheckCircleOutlineOutlined: 'Circle',
  CheckCircleOutlineRounded: 'Circle',
  CheckCircleOutlineSharp: 'Circle',
  CheckCircleOutlineTwoTone: 'Circle',
  CheckCircleRounded: 'CheckCircle2',
  CheckCircleSharp: 'CheckCircle2',
  ChecklistRtlOutlined: 'ListChecks',
  CheckOutlined: 'Check',
  ChildCare: 'Baby',
  ChromeReaderModeTwoTone: 'BookOpen',
  CircleNotificationsRounded: 'Bell',
  CircleOutlined: 'Circle',
  CircleRounded: 'Circle',
  CircleTwoTone: 'Circle',
  CleanHands: 'Hand',
  CleanHandsOutlined: 'Hand',
  CleanHandsRounded: 'Hand',
  CleanHandsTwoTone: 'Hand',
  CleaningServices: 'Sparkles',
  CleaningServicesOutlined: 'Sparkles',
  Cloud: 'Cloud',
  CloudDone: 'CloudCog',
  CloudDoneOutlined: 'CloudCog',
  CloudDoneRounded: 'CloudCog',
  CloudDoneTwoTone: 'CloudCog',
  CloudQueueRounded: 'Cloud',
  CollectionsBookmark: 'Bookmark',
  CommentSharp: 'MessageSquare',
  CompareArrows: 'ArrowLeftRight',
  CompareArrowsRounded: 'ArrowLeftRight',
  Computer: 'Monitor',
  ComputerTwoTone: 'Monitor',
  Construction: 'Construction',
  ConstructionOutlined: 'Construction',
  ConstructionRounded: 'Construction',
  ContactPage: 'Contact',
  ContactPhoneRounded: 'Phone',
  ContentPasteSearch: 'ClipboardList',
  CreateNewFolder: 'FolderPlus',
  CrisisAlert: 'Siren',
  CurrencyExchange: 'ArrowLeftRight',
  Cyclone: 'Tornado',
  DangerousOutlined: 'TriangleAlert',
  DeliveryDining: 'Bike',
  DeliveryDiningOutlined: 'Bike',
  DeliveryDiningTwoTone: 'Bike',
  DepartureBoard: 'Train',
  DepartureBoardOutlined: 'Train',
  DepartureBoardSharp: 'Train',
  DescriptionTwoTone: 'FileText',
  DesignServicesOutlined: 'PenTool',
  Details: 'List',
  DetailsOutlined: 'List',
  DevicesOtherRounded: 'Smartphone',
  DirectionsBikeRounded: 'Bike',
  DirectionsCar: 'Car',
  DirectionsCarFilled: 'Car',
  DirectionsCarFilledOutlined: 'Car',
  DirectionsCarFilledRounded: 'Car',
  DirectionsCarFilledSharp: 'Car',
  DirectionsCarFilledTwoTone: 'Car',
  DirectionsCarOutlined: 'Car',
  DirectionsCarSharp: 'Car',
  DirectionsCarTwoTone: 'Car',
  DirectionsTransit: 'Bus',
  DirectionsTransitFilledOutlined: 'Bus',
  DirectionsTransitOutlined: 'Bus',
  DirectionsTransitSharp: 'Bus',
  DirectionsWalk: 'Footprints',
  DirectionsWalkOutlined: 'Footprints',
  DirectionsWalkRounded: 'Footprints',
  DirectionsWalkSharp: 'Footprints',
  DocumentScanner: 'ScanText',
  DocumentScannerOutlined: 'ScanText',
  DocumentScannerTwoTone: 'ScanText',
  Done: 'Check',
  DoneAllTwoTone: 'CheckCheck',
  DoneOutline: 'Circle',
  DoneOutlineOutlined: 'Circle',
  DoneOutlineRounded: 'Circle',
  DoneOutlineSharp: 'Circle',
  DoneOutlineTwoTone: 'Circle',
  DoNotDisturbAltOutlined: 'Ban',
  DoorBack: 'DoorClosed',
  DoorBackOutlined: 'DoorClosed',
  DoorBackRounded: 'DoorClosed',
  DoorBackSharp: 'DoorClosed',
  DoorBackTwoTone: 'DoorClosed',
  DoorFrontOutlined: 'DoorOpen',
  DriveEta: 'Car',
  DriveEtaOutlined: 'Car',
  DriveEtaRounded: 'Car',
  DriveEtaTwoTone: 'Car',
  DriveFileMoveOutlined: 'FolderInput',
  DriveFileMoveSharp: 'FolderInput',
  DriveFileRenameOutline: 'FilePen',
  EditRoad: 'Route',
  ElectricBolt: 'Zap',
  ElectricBoltOutlined: 'Zap',
  ElectricCar: 'Car',
  ElectricCarSharp: 'Car',
  ElectricCarTwoTone: 'Car',
  ElectricRickshawRounded: 'Car',
  EmailOutlined: 'Mail',
  EmojiFlags: 'Flag',
  EmojiPeopleOutlined: 'User',
  EmojiTransportation: 'Car',
  EmojiTransportationOutlined: 'Car',
  EmojiTransportationRounded: 'Car',
  EmojiTransportationSharp: 'Car',
  EmojiTransportationTwoTone: 'Car',
  Engineering: 'HardHat',
  EngineeringOutlined: 'HardHat',
  EngineeringRounded: 'HardHat',
  Error: 'AlertCircle',
  EventNoteSharp: 'Calendar',
  EventSeat: 'Armchair',
  EventSeatOutlined: 'Armchair',
  EventSeatRounded: 'Armchair',
  EventSeatSharp: 'Armchair',
  EventSeatTwoTone: 'Armchair',
  Facebook: 'Facebook',
  FacebookOutlined: 'Facebook',
  FactCheck: 'ClipboardCheck',
  FactCheckOutlined: 'ClipboardCheck',
  FactCheckRounded: 'ClipboardCheck',
  FactCheckSharp: 'ClipboardCheck',
  FactCheckTwoTone: 'ClipboardCheck',
  FeaturedPlayList: 'ListVideo',
  FeaturedPlayListOutlined: 'ListVideo',
  FeaturedPlayListTwoTone: 'ListVideo',
  FiberNewOutlined: 'Sparkles',
  FileOpenSharp: 'FolderOpen',
  FilePresent: 'File',
  FileUpload: 'Upload',
  FilterFrames: 'Frame',
  FilterFramesOutlined: 'Frame',
  FindInPageOutlined: 'FileSearch',
  FireTruck: 'Truck',
  FireTruckOutlined: 'Truck',
  FireTruckRounded: 'Truck',
  FireTruckSharp: 'Truck',
  FireTruckTwoTone: 'Truck',
  FlightLandRounded: 'PlaneLanding',
  FolderCopyOutlined: 'Copy',
  FormatAlignJustify: 'AlignJustify',
  FormatListBulleted: 'List',
  FormatListBulletedOutlined: 'List',
  FormatListBulletedRounded: 'List',
  FormatListNumbered: 'ListOrdered',
  FormatPaint: 'Paintbrush',
  FormatPaintOutlined: 'Paintbrush',
  FormatPaintRounded: 'Paintbrush',
  FormatPaintSharp: 'Paintbrush',
  FormatPaintTwoTone: 'Paintbrush',
  FormatUnderlined: 'Underline',
  Gavel: 'Gavel',
  GppGoodTwoTone: 'ShieldCheck',
  GpsFixed: 'LocateFixed',
  GpsFixedOutlined: 'LocateFixed',
  GpsFixedTwoTone: 'LocateFixed',
  GridViewRounded: 'LayoutGrid',
  GroupRemove: 'UserMinus',
  HandshakeOutlined: 'Handshake',
  Handyman: 'Hammer',
  HandymanOutlined: 'Hammer',
  HandymanTwoTone: 'Hammer',
  HealthAndSafety: 'Shield',
  HealthAndSafetyOutlined: 'Shield',
  HeartBroken: 'HeartCrack',
  HeartBrokenSharp: 'HeartCrack',
  HighQuality: 'BadgeCheck',
  HighQualityOutlined: 'BadgeCheck',
  HomeRepairService: 'Wrench',
  HomeRepairServiceOutlined: 'Wrench',
  HomeRepairServiceRounded: 'Wrench',
  HomeRepairServiceSharp: 'Wrench',
  HomeRepairServiceTwoTone: 'Wrench',
  HomeWork: 'House',
  HourglassBottom: 'Hourglass',
  HourglassEmpty: 'Hourglass',
  HourglassTopOutlined: 'Hourglass',
  HourglassTopTwoTone: 'Hourglass',
  House: 'House',
  Image: 'Image',
  ImageSearch: 'Image',
  ImageSearchOutlined: 'Image',
  ImageSearchRounded: 'Image',
  ImageTwoTone: 'Image',
  InsertDriveFile: 'File',
  InsertDriveFileOutlined: 'File',
  InsertPageBreakOutlined: 'SeparatorHorizontal',
  insertPhoto: 'Image',
  InsertPhoto: 'Image',
  InsertPhotoSharp: 'Image',
  InventoryOutlined: 'Package',
  Key: 'Key',
  KeyboardAltOutlined: 'Keyboard',
  KeyboardArrowLeftOutlined: 'ChevronLeft',
  KeyboardReturn: 'CornerDownLeft',
  KeyOutlined: 'Key',
  KeyRounded: 'Key',
  KeySharp: 'Key',
  LibraryAddCheck: 'Library',
  LibraryAddCheckOutlined: 'Library',
  LibraryAddCheckSharp: 'Library',
  LibraryAddCheckTwoTone: 'Library',
  LibraryMusicOutlined: 'Music',
  LightOutlined: 'Lightbulb',
  LineWeightRounded: 'Minus',
  LinkedCameraTwoTone: 'Camera',
  ListAlt: 'List',
  ListAltOutlined: 'List',
  ListAltSharp: 'List',
  ListAltTwoTone: 'List',
  LocalCarWash: 'Car',
  LocalCarWashOutlined: 'Car',
  LocalCarWashRounded: 'Car',
  LocalCarWashSharp: 'Car',
  LocalCarWashTwoTone: 'Car',
  LocalFireDepartmentOutlined: 'Flame',
  LocalFireDepartmentTwoTone: 'Flame',
  LocalGasStation: 'Fuel',
  LocalParking: 'CircleParking',
  LocalPhoneRounded: 'Phone',
  LocalPrintshop: 'Printer',
  LocalPrintshopOutlined: 'Printer',
  LocalShipping: 'Truck',
  LocalShippingRounded: 'Truck',
  LocalShippingTwoTone: 'Truck',
  LocationOn: 'MapPin',
  LogoutRounded: 'LogOut',
  LogoutSharp: 'LogOut',
  ManageAccounts: 'UserCog',
  ManageAccountsOutlined: 'UserCog',
  ManageSearchOutlined: 'Search',
  MarkChatReadOutlined: 'MessageSquare',
  MarkChatReadSharp: 'MessageSquare',
  Mediation: 'Users',
  MenuBookTwoTone: 'BookOpen',
  ModeOfTravelRounded: 'Plane',
  MonetizationOn: 'CircleDollarSign',
  MonetizationOnOutlined: 'CircleDollarSign',
  Money: 'Banknote',
  MoneyTwoTone: 'Banknote',
  MonitorHeart: 'HeartPulse',
  MonitorHeartOutlined: 'HeartPulse',
  MonitorHeartTwoTone: 'HeartPulse',
  MonochromePhotos: 'Image',
  MonochromePhotosSharp: 'Image',
  MoodBad: 'Frown',
  MoveDown: 'ArrowDown',
  NearbyError: 'AlertCircle',
  NewReleases: 'Sparkles',
  NewReleasesOutlined: 'Sparkles',
  NewReleasesRounded: 'Sparkles',
  NewReleasesSharp: 'Sparkles',
  NewReleasesTwoTone: 'Sparkles',
  Newspaper: 'Newspaper',
  NewspaperOutlined: 'Newspaper',
  NewspaperRounded: 'Newspaper',
  NewspaperTwoTone: 'Newspaper',
  NextPlanOutlined: 'CalendarPlus',
  NoteAltRounded: 'StickyNote',
  NotificationsActiveOutlined: 'BellRing',
  NotInterested: 'Ban',
  NotStarted: 'CirclePlay',
  OilBarrel: 'Fuel',
  OilBarrelOutlined: 'Fuel',
  OndemandVideo: 'Video',
  PanTool: 'Hand',
  PanToolAltOutlined: 'Hand',
  PartyMode: 'PartyPopper',
  PaymentsSharp: 'CreditCard',
  PedalBike: 'Bike',
  PendingActions: 'ClipboardList',
  PendingOutlined: 'Clock',
  PeopleOutline: 'Users',
  Person: 'User',
  PersonAddAlt: 'UserPlus',
  PhoneAndroid: 'Smartphone',
  PhoneCallback: 'PhoneIncoming',
  PhotoCameraRounded: 'Camera',
  PhotoSizeSelectActual: 'Image',
  PictureAsPdf: 'FileText',
  PictureInPicture: 'PictureInPicture',
  PlaylistAddCheckCircleOutlined: 'ListChecks',
  PlaylistAddCheckCircleSharp: 'ListChecks',
  PlaylistAddCheckCircleTwoTone: 'ListChecks',
  PlaylistAddCheckOutlined: 'ListChecks',
  PointOfSaleSharp: 'Store',
  PostAdd: 'FilePlus',
  Preview: 'Eye',
  PriceChange: 'TrendingUp',
  PriceChangeOutlined: 'TrendingUp',
  PriceChangeTwoTone: 'TrendingUp',
  PriceCheck: 'BadgeCheck',
  PrivacyTipOutlined: 'Shield',
  PunchClockOutlined: 'Clock',
  PunchClockSharp: 'Clock',
  QrCode: 'QrCode',
  QuestionMark: 'CircleHelp',
  Radio: 'Radio',
  RadioOutlined: 'Radio',
  RecordVoiceOverOutlined: 'Mic',
  Refresh: 'RefreshCw',
  RemoveCircleOutlined: 'CircleMinus',
  RemoveModeratorTwoTone: 'ShieldOff',
  RemoveRedEye: 'Eye',
  RemoveRedEyeOutlined: 'Eye',
  RemoveRedEyeSharp: 'Eye',
  RemoveRedEyeTwoTone: 'Eye',
  ReorderRounded: 'GripVertical',
  RepartitionOutlined: 'Split',
  ReportGmailerrorredOutlined: 'AlertCircle',
  ReportProblemOutlined: 'AlertTriangle',
  RequestPage: 'FileText',
  RestartAlt: 'RotateCcw',
  RestoreFromTrash: 'ArchiveRestore',
  RestoreOutlined: 'RotateCcw',
  RestorePageOutlined: 'File',
  RocketLaunchOutlined: 'Rocket',
  RoomServiceOutlined: 'ConciergeBell',
  RunCircle: 'CirclePlay',
  RunCircleRounded: 'CirclePlay',
  SafetyCheckSharp: 'ShieldCheck',
  ScatterPlotOutlined: 'ChartScatter',
  Schedule: 'Clock',
  ScheduleSendTwoTone: 'Send',
  ScheduleSharp: 'Clock',
  SdCardAlertTwoTone: 'AlertTriangle',
  SellOutlined: 'Tag',
  SensorDoorOutlined: 'DoorOpen',
  SensorDoorSharp: 'DoorOpen',
  SensorWindowOutlined: 'AppWindow',
  SensorWindowTwoTone: 'AppWindow',
  ShieldOutlined: 'Shield',
  ShoppingBag: 'ShoppingBag',
  ShoppingBasket: 'ShoppingBasket',
  ShoppingCart: 'ShoppingCart',
  ShoppingCartCheckout: 'ShoppingCart',
  ShoppingCartCheckoutOutlined: 'ShoppingCart',
  ShoppingCartCheckoutRounded: 'ShoppingCart',
  ShoppingCartOutlined: 'ShoppingCart',
  Shower: 'ShowerHead',
  SignalCellularConnectedNoInternet4BarOutlined: 'WifiOff',
  SkipNextRounded: 'SkipForward',
  SmsFailed: 'MessageSquareX',
  SpeakerGroupOutlined: 'Speaker',
  SpeakerNotesOutlined: 'MessageSquare',
  Speed: 'Gauge',
  SpellcheckRounded: 'SpellCheck',
  SportsFootballOutlined: 'Circle',
  StickyNote2: 'StickyNote',
  StickyNote2Outlined: 'StickyNote',
  StickyNote2TwoTone: 'StickyNote',
  StorefrontOutlined: 'Store',
  Streetview: 'Map',
  Subtitles: 'Subtitles',
  SubtitlesRounded: 'Subtitles',
  SubtitlesTwoTone: 'Subtitles',
  SwitchVideoOutlined: 'SwitchCamera',
  TagFaces: 'Smile',
  TagFacesSharp: 'Smile',
  Task: 'ClipboardCheck',
  TaskOutlined: 'ClipboardCheck',
  TaskSharp: 'ClipboardCheck',
  ThumbDownAltOutlined: 'ThumbsDown',
  ThumbDownOffAltRounded: 'ThumbsDown',
  ThumbsUpDownTwoTone: 'ThumbsUp',
  ThumbUp: 'ThumbsUp',
  ThumbUpAlt: 'ThumbsUp',
  ThumbUpAltOutlined: 'ThumbsUp',
  ThumbUpAltRounded: 'ThumbsUp',
  ThumbUpOffAltOutlined: 'ThumbsUp',
  ThumbUpOutlined: 'ThumbsUp',
  TimeToLeaveSharp: 'Car',
  TireRepair: 'Circle',
  TireRepairOutlined: 'Circle',
  TireRepairRounded: 'Circle',
  TireRepairSharp: 'Circle',
  TireRepairTwoTone: 'Circle',
  Title: 'Heading',
  TitleOutlined: 'Heading',
  TouchAppOutlined: 'Pointer',
  TouchAppRounded: 'Pointer',
  Train: 'Train',
  TrainOutlined: 'Train',
  TrainRounded: 'Train',
  TransferWithinAStation: 'ArrowLeftRight',
  TwoWheeler: 'Bike',
  TwoWheelerOutlined: 'Bike',
  Umbrella: 'Umbrella',
  UploadFileSharp: 'Upload',
  ViewHeadlineOutlined: 'AlignJustify',
  ViewListTwoTone: 'List',
  Warehouse: 'Warehouse',
  Warning: 'AlertTriangle',
  WarningAmber: 'AlertTriangle',
  WarningAmberRounded: 'AlertTriangle',
  WarningAmberSharp: 'AlertTriangle',
  WarningTwoTone: 'AlertTriangle',
  Wash: 'Droplets',
  WashTwoTone: 'Droplets',
  WbSunnySharp: 'Sun',
  Web: 'Globe',
  WebAssetSharp: 'Monitor',
  WhereToVote: 'MapPin',
  WhereToVoteOutlined: 'MapPin',
  WidgetsTwoTone: 'LayoutGrid',
  WifiProtectedSetup: 'Wifi',
  Window: 'AppWindow',
  WindowOutlined: 'AppWindow',
  WindowRounded: 'AppWindow',
  WindowSharp: 'AppWindow',
  WindowTwoTone: 'AppWindow',
  WindPower: 'Wind',
  WindPowerOutlined: 'Wind',
  Work: 'Briefcase',
  WorkspacePremium: 'Award',
} as const;

export const getIconNames = (): string[] => {
  return [...new Set(Object.values(iconMap))];
};

export type IconName = keyof typeof iconMap;
